// src/environments/environment.ts
export const environment = {
  production: false,
  apiKey: 'AIzaSyDjrlS6T7pewveitnSy0iUG32DW3IURMy0',
};

export const API = {
  production: false,
  apiUrl: 'https://api.aws.cisassist.com.au/public/future/members/',
};
